import { useSyncReceiptLocaleOnLanguageChange } from '../features/account/useSyncReceiptLocaleOnLanguageChange.js';

/** Keeps Default receipt uiLocale aligned with i18n for logged-in customers. */
export function ReceiptLocaleUiSync(): null {
  useSyncReceiptLocaleOnLanguageChange();
  return null;
}
